export class TrPlayerSession {

    constructor(
        public muted: boolean = false,
        public captionsEnabled: boolean = false,
        public lastClip: number = null,
    ) {

    }
}
